import tickSrc from "./assets/icons/noun-tick.svg";
import crossSrc from "./assets/icons/noun-cross.svg";

const iconStyle = { width: "0.85em", height: "0.85em", verticalAlign: "-0.1em" };

export const IconTick = <img src={tickSrc} alt="✓" style={iconStyle} />;
export const IconCross = <img src={crossSrc} alt="✕" style={iconStyle} />;
